module.exports = __webpack_public_path__ + "media/how-it-works/map-ae9c7022.png";